var map = {
	"./android.svg": 57552,
	"./angular.svg": 45495,
	"./apple-logo.svg": 89239,
	"./apple.svg": 90081,
	"./audio.svg": 63823,
	"./aws.svg": 59070,
	"./black.svg": 92560,
	"./channel-01.svg": 23796,
	"./channel-02.svg": 95303,
	"./channel-03.svg": 8182,
	"./channel-04.svg": 83417,
	"./channel-05.svg": 75496,
	"./channel-06.svg": 56859,
	"./channel-07.svg": 39018,
	"./channel-08.svg": 59869,
	"./clinic.svg": 3179,
	"./close-circle.png": 812,
	"./close-circle.svg": 17594,
	"./cloud.svg": 93822,
	"./company-icon-11.svg": 58409,
	"./company-icon-12.svg": 13594,
	"./company-icon-13.svg": 91115,
	"./company-icon-14.svg": 23524,
	"./company-icon-15.svg": 20773,
	"./company-icon-16.svg": 88998,
	"./company-icon-17.svg": 77975,
	"./company-icon-18.svg": 42144,
	"./connected-app-01.svg": 39074,
	"./connected-app-02.svg": 9969,
	"./connected-app-03.svg": 47168,
	"./connected-app-04.png": 95429,
	"./connected-app-04.svg": 89375,
	"./delete.svg": 4738,
	"./devops.svg": 16452,
	"./drag-drop.svg": 31641,
	"./drive.svg": 57057,
	"./dropbox.svg": 14347,
	"./emoji-01.svg": 72829,
	"./emoji-smile.svg": 11824,
	"./emonji-02.svg": 78640,
	"./emonji-03.svg": 14177,
	"./emonji-04.svg": 798,
	"./emonji-05.svg": 28175,
	"./emonji-06.svg": 49148,
	"./emonji-07.svg": 38621,
	"./emonji-08.svg": 51946,
	"./emonji-09.svg": 12315,
	"./emonji-10.svg": 37293,
	"./facebook-logo.svg": 14981,
	"./fb-icon.svg": 71987,
	"./feeds-01.svg": 28930,
	"./feeds-02.svg": 49297,
	"./feeds-03.svg": 13344,
	"./feeds-04.svg": 79231,
	"./file-01.svg": 31755,
	"./file-02.svg": 92920,
	"./file-03.svg": 27785,
	"./file-04.svg": 25190,
	"./file-05.svg": 12727,
	"./file.svg": 58469,
	"./folder-icon.svg": 20143,
	"./folder-minus.svg": 36828,
	"./folder.svg": 34219,
	"./global-img.svg": 91188,
	"./google-icon-02.svg": 45111,
	"./google-icon.svg": 68648,
	"./google-logo.svg": 30734,
	"./google-meet.svg": 29738,
	"./grafic.svg": 35537,
	"./half-circle.svg": 53421,
	"./heart.svg": 45685,
	"./hi.svg": 5586,
	"./html.svg": 62100,
	"./image.svg": 59682,
	"./img.svg": 87496,
	"./kanban-arrow.svg": 98130,
	"./laravel-icon.svg": 91708,
	"./laravel.svg": 91074,
	"./like.svg": 99358,
	"./liked-page-01.svg": 29626,
	"./liked-page-02.svg": 71561,
	"./liked-page-03.svg": 96056,
	"./liked-page-04.svg": 91127,
	"./medal-2.svg": 43469,
	"./medal.svg": 71360,
	"./modal-small-logo.svg": 60284,
	"./nodejs.svg": 88202,
	"./pause.svg": 34299,
	"./pause1.svg": 43152,
	"./pdf-02.svg": 99150,
	"./pdf-icon.svg": 5079,
	"./pdf.svg": 17603,
	"./php-icon.svg": 4437,
	"./php.svg": 33761,
	"./play-01.svg": 90747,
	"./polygon-icon.svg": 18995,
	"./react.svg": 69264,
	"./scanner.svg": 94075,
	"./scanners.svg": 50194,
	"./signature.svg": 76467,
	"./smile-chat.svg": 18220,
	"./sms-icon-01.svg": 89416,
	"./sms-icon-02.svg": 70779,
	"./sms-icon-03.svg": 28810,
	"./smtp-icon.svg": 88075,
	"./staff.svg": 75543,
	"./storage-icon-01.svg": 74908,
	"./storage-icon-02.svg": 53935,
	"./storage-icon-03.svg": 10206,
	"./storage.svg": 92470,
	"./student.svg": 44900,
	"./subject.svg": 47273,
	"./success-tick.svg": 47246,
	"./teacher.svg": 86203,
	"./twitter-icon.svg": 47746,
	"./ui.svg": 10541,
	"./upgrade.svg": 50185,
	"./video.svg": 57123,
	"./voice.svg": 15903,
	"./xls-icon.svg": 16504,
	"./xls.svg": 20958,
	"./zip.svg": 52776
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 59945;